var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"zone",staticClass:"eui-o-signPDFViewer__zone",style:(_vm.styleObject)},[_c('div',{staticClass:"eui-o-signPDFViewer__icone"},[_c('SignIcon',{style:(_vm.iconStyleObject),attrs:{"color":"primary"}})],1),_vm._v(" "),(_vm.$slots.default)?_c('div',{staticClass:"eui-o-signPDFViewer__text"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }